import { ReactNode } from 'react';
import { Classes, Label } from '@blueprintjs/core';
import { IData, MultiSelect } from '../MultiSelect';
import styles from './MultiFilterSelect.module.css';
import { classNames } from '../../utils/classNames';

export function MultiFilterSelect<T extends IData>({
  label,
  items,
  onSelect,
  onRemove,
  values,
  description,
  stringify,
  disabled,
}: {
  label: string;
  items: T[];
  onSelect(item: T): void;
  onRemove(item: ReactNode, index: number): void;
  values: T[];
  description?: string;
  stringify(item: T): string;
  disabled?: boolean;
}) {
  return (
    <div className={classNames(Classes.LABEL, styles.container)}>
      {/* Label must be sibling to MultiSelect or it will cause errors.
      https://github.com/palantir/blueprint/issues/3058#issuecomment-432275232 */}
      <Label className={styles.label}>
        <span className={styles.noWrap}>{label}</span>
      </Label>
      <MultiSelect<T>
        className={styles.buttonText}
        data={items}
        onSelect={onSelect}
        onRemove={onRemove}
        stringify={stringify}
        values={values}
        disabled={disabled}
      />
      <span className={styles.description}>{description}</span>
    </div>
  );
}
